import Vue from 'vue';
import Router from 'vue-router';
import base from './base';
import ErrorPage from '../pages/Error'
// 解决点击两次相同路由报错
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err);
// };
Vue.use(Router);

const list = [{ path: '*', name: '404', component: ErrorPage, meta: { auth: false } },
  ...base];

export default new Router({
  mode: 'history',
  routes: list,
});
